import React from 'react';

import Icon, { Props } from './icon';

export const FavoritesListIcon: React.FC<Props> = (props: Props) => {
  return (
    <Icon {...props}>
      <path d="m2,5.03c0-.57.46-1.03,1.03-1.03h17.94c.57,0,1.03.46,1.03,1.03v13.94c0,.57-.46,1.03-1.03,1.03H3.03c-.57,0-1.03-.46-1.03-1.03V5.03Zm2,.97v12h16V6H4Zm1.5,7.05c0-.41.34-.75.75-.75h5c.41,0,.75.34.75.75s-.34.75-.75.75h-5c-.41,0-.75-.34-.75-.75Zm7.25,1.95c-.41,0-.75.34-.75.75s.34.75.75.75h5c.41,0,.75-.34.75-.75s-.34-.75-.75-.75h-5Zm1.25-1.95c0-.41.34-.75.75-.75h3c.41,0,.75.34.75.75s-.34.75-.75.75h-3c-.41,0-.75-.34-.75-.75Zm-7.75,1.95c-.41,0-.75.34-.75.75s.34.75.75.75h3c.41,0,.75-.34.75-.75s-.34-.75-.75-.75h-3Z" />
    </Icon>
  );
};

export default FavoritesListIcon;
